export default {
  path: '/companies/:id',
  name: 'Company',
  component: () => import(/* webpackChunkName: "base" */ '../views/CompanyView.vue')
}
